import { apiPost } from "./apiClient";

// Entries come back either as plain strings or {value,label}/{name}-shaped
// objects depending on how the row was originally saved — same defensive
// normalization hand-duplicated across CustomerEditDrawer, EditDraftDrawer,
// WorkflowTaskDrawer, and VehicleBrandModelModal.
export function normalizePartInfoList(list) {
  return (list || []).map(p =>
    typeof p === "string" ? { value: p, label: p } : { value: p.value ?? p.name, label: p.label ?? p.name ?? p.value }
  );
}

export function fetchPartInfoOptions() {
  return apiPost("/whatsapp/get_parts_info", {})
    .then(res => normalizePartInfoList(Array.isArray(res.data) ? res.data : (res.data?.data ?? [])))
    .catch(() => []);
}

export function addPartInfo(value) {
  return apiPost("/whatsapp/add_new_part_info", { value }).then(res => res.data);
}
